import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getProStock } from '../../../../Store/prosafe/proStock/getProStock';
import Header from '../../Include/Header';
import Sidebar from '../../Include/Sidebar';
import Footer from '../../Include/Footer';
import Loader from '../../Include/Loader';
import { Pagination, Search } from '../../Table';
import DropDown from '../../../../Components/DropDown';
import { ArrowDown, ArrowUp, Layers, PackageCheck } from 'lucide-react';


const ProStockList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [totalItems, setTotalItems] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [search, setSearch] = useState("");
    const [limit, setlimit] = useState(10);
    const [disable, setDisable] = useState(true);
    const [filter, setFilter] = useState({
        date: {
            start: null,
            end: null
        }
    });

    useEffect(() => {
        if (disable === true) {
            fetchData()
        }
    }, [disable]);

    const fetchData = () => {
        const bodyFormData = new URLSearchParams();
        bodyFormData.append("filter", JSON.stringify(filter));
        bodyFormData.append('firm_id', localStorage.getItem('PAY_USER_FIRM_ID'))
        // bodyFormData.append('year_id', localStorage.getItem('PAY_USER_YEAR_ID'))
        dispatch(getProStock({ formData: bodyFormData }))
        setDisable(false);
    };

    const entity = useSelector((state) => state.getProStock?.user?.data);

    const commentsData = useMemo(() => {
        let computedComments = entity?.store_items || [];

        if (search) {
            computedComments = computedComments.filter(
                (stock) =>
                    stock.item_name?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    stock.unit?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    stock.material_grade?.toLowerCase()?.includes(search?.toLowerCase()) ||
                    stock.m_code?.toString()?.toLowerCase()?.includes(search?.toLowerCase())
            );
        }
        setTotalItems(computedComments?.length);

        return computedComments?.slice(
            (currentPage - 1) * limit,
            (currentPage - 1) * limit + limit
        );
    }, [currentPage, search, limit, entity]);

    const handleRefresh = () => {
        setDisable(true);
        setSearch('');
        setFilter({
            date: {
                start: null,
                end: null
            }
        });
    }

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const handleOpen = () => {
        setIsSidebarOpen(!isSidebarOpen)
    }

    return (
        <div className={`main-wrapper ${isSidebarOpen ? "slide-nav" : ""}`}>
            <Header handleOpen={handleOpen} />
            <Sidebar />

            <div className="page-wrapper">
                <div className="content">
                    <div className="page-header">
                        <div className="row">
                            <div className="col-sm-12">
                                <ul className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/main-store/user/dashboard">Dashboard </Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <i className="feather-chevron-right"></i>
                                    </li>
                                    <li className="breadcrumb-item active">Stock</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    {disable === false ? (
                        <>
                            <div className="row g-3 mb-3">
                                <div className="col-md-3">
                                    <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                        <div className="card-body d-flex align-items-center">
                                            <div className="bg-primary text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                                <Layers size={24} />
                                            </div>
                                            <div>
                                                <h6 className="mb-0 text-muted">Opening Balance</h6>
                                                <h5 className="mb-0">{entity?.total_op_bal ?? 0}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                        <div className="card-body d-flex align-items-center">
                                            <div className="bg-success text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                                <ArrowDown size={24} />
                                            </div>
                                            <div>
                                                <h6 className="mb-0 text-muted">Total In</h6>
                                                <h5 className="mb-0">{entity?.total_in ?? 0}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                        <div className="card-body d-flex align-items-center">
                                            <div className="bg-danger text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                                <ArrowUp size={24} />
                                            </div>
                                            <div>
                                                <h6 className="mb-0 text-muted">Total Out</h6>
                                                <h5 className="mb-0">{entity?.total_out ?? 0}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-md-3">
                                    <div className="card shadow-sm border-0 bg-light rounded-3 h-100">
                                        <div className="card-body d-flex align-items-center">
                                            <div className="bg-warning text-white p-3 rounded-circle me-3 d-flex align-items-center justify-content-center" style={{ width: 50, height: 50 }}>
                                                <PackageCheck size={24} />
                                            </div>
                                            <div>
                                                <h6 className="mb-0 text-muted">Total Balance</h6>
                                                <h5 className="mb-0">{entity?.total_balance ?? 0}</h5>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="card card-table show-entire">
                                        <div className="card-body">
                                            <div className="page-table-header mb-2">
                                                <div className="row align-items-center">
                                                    <div className="col">
                                                        <div className="doctor-table-blk">
                                                            <h3>Stock</h3>
                                                            <div className="doctor-search-blk">
                                                                <div className="top-nav-search table-search-blk">
                                                                    <form>
                                                                        <Search
                                                                            onSearch={(value) => {
                                                                                setSearch(value);
                                                                                setCurrentPage(1);
                                                                            }}
                                                                        />
                                                                        {/* eslint-disable jsx-a11y/anchor-is-valid */}
                                                                        <a className="btn">
                                                                            <img src="/assets/img/icons/search-normal.svg" alt="firm-searchBox" />
                                                                        </a>
                                                                    </form>
                                                                </div>
                                                                <div className="add-group">
                                                                    <button type="button" onClick={handleRefresh} className="btn btn-primary doctor-refresh ms-2"
                                                                        data-toggle="tooltip" data-placement="top" title="Refresh">
                                                                        <img src="/assets/img/icons/re-fresh.svg" alt="refresh" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="pageDropDown col-auto text-end float-end ms-auto download-grp">
                                                        <DropDown limit={limit} onLimitChange={(val) => setlimit(val)} />
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="table-responsive">
                                                <table className="table border-0 custom-table comman-table  mb-0">
                                                    <thead>
                                                        <tr>
                                                            <th>Sr.</th>
                                                            <th>Item Name</th>
                                                            <th>Opening Balance</th>
                                                            <th>Total In</th>
                                                            <th>Total Out</th>
                                                            <th>Balance</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {commentsData?.map((elem, i) => (
                                                            <tr key={elem?.item_id || i}>
                                                                <td>{(currentPage - 1) * limit + i + 1}</td>
                                                                <td>{elem?.item_name || '-'}</td>
                                                                <td>{elem?.opening_balance ?? 0}</td>
                                                                <td>{elem?.date_totalIn ?? 0}</td>
                                                                <td>{elem?.date_totalOut ?? 0}</td>
                                                                <td>{elem?.balance ?? 0}</td>
                                                            </tr>
                                                        ))}
                                                        {commentsData?.length === 0 ? (
                                                            <tr>
                                                                <td colSpan="999">
                                                                    <div className="no-table-data">
                                                                        No Data Found!
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        ) : null}
                                                    </tbody>
                                                </table>
                                            </div>
                                            <div className="row align-center mt-3 mb-2">
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6">
                                                    <div className="dataTables_info" id="DataTables_Table_0_info" role="status"
                                                        aria-live="polite">Showing {Math.min(limit, totalItems)} from {totalItems} data</div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 col-lg-6 col-xxl-6 ">
                                                    <div className="dataTables_paginate paging_simple_numbers"
                                                        id="DataTables_Table_0_paginate">
                                                        <Pagination
                                                            total={totalItems}
                                                            itemsPerPage={limit}
                                                            currentPage={currentPage}
                                                            onPageChange={(page) => setCurrentPage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </>
                    ) : <Loader />}

                </div>
                <Footer />
            </div>
        </div>
    )
}

export default ProStockList